import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaArCatNode.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return (
                'AR' === type ||
                CategoryNode.canMountType.call(this, map, node, type)
            )
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'AR'},
            ]
        },

        async _atPull(map, node) {
            await CategoryNode._atPull.call(this, map, node)
            node.isFolded = true
        },

        _fixChild(map, node, child) {
            return map.BizNode.AR._fixChild(map, node, child)
        },
    })
}
